if (!customElements.get('product-showcase-carousel')) {
  customElements.define(
    'product-showcase-carousel',
    class extends HTMLElement {
      connectedCallback() {
        this._track = this.querySelector('[data-track]');
        this._fill  = this.querySelector('[data-progress-fill]');
        this._prev  = this.querySelector('[data-prev]');
        this._next  = this.querySelector('[data-next]');

        if (!this._track) return;

        this._onScroll = () => this._sync();
        this._onResize = () => this._sync();

        this._track.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize, { passive: true });

        if (this._prev) this._prev.addEventListener('click', () => this._scroll(-1));
        if (this._next) this._next.addEventListener('click', () => this._scroll(1));

        this._sync();
        this._observeReveal();
      }

      _observeReveal() {
        if (!('IntersectionObserver' in window)) {
          this.classList.add('mox-product-carousel--revealed');
          return;
        }
        const io = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) {
              this.classList.add('mox-product-carousel--revealed');
              io.disconnect();
            }
          },
          { threshold: 0.15 }
        );
        io.observe(this);
      }

      disconnectedCallback() {
        this._track?.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
      }

      _scroll(dir) {
        const card = this._track.querySelector('.mox-product-card');
        if (!card) return;
        const gap = parseInt(getComputedStyle(this._track).gap) || 16;
        this._track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      _sync() {
        const { scrollLeft, scrollWidth, clientWidth } = this._track;
        const max = scrollWidth - clientWidth;

        // Progress bar — viewport indicator (visible width + scroll offset / total)
        if (this._fill) {
          const pct = scrollWidth > 0 ? ((scrollLeft + clientWidth) / scrollWidth) * 100 : 0;
          this._fill.style.width = `${Math.min(pct, 100)}%`;
        }

        // Arrows — show prev when not at start, next when not at end
        if (this._prev) this._prev.hidden = scrollLeft <= 2;
        if (this._next) this._next.hidden = max <= 0 || scrollLeft >= max - 2;
      }
    }
  );
}
